import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffDeliverTimesNew from '../delivery/TaroffDeliverTimesNew';
import { postData } from '../../Api';

export default function TaroffDeliverTimes(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        setModal(
            Modal({
                children: <TaroffDeliverTimesNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp2 = () => {
        setModal(
            Modal({
                children: <TaroffDeliverTimesNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-deliver-times/table-data', {
            size: tableSize,
            page: tablePage,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>زمان های ارسال</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        ایجاد زمان ارسال
                    </Button>
                </LeftComponents>
            </Row>
            <Row>
                <RightComponents>
                    <Title>زمان های ارسال</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        ایجاد زمان ارسال
                    </Button>
                </LeftComponents>
            </Row>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>شناسه</TableColumn>
                        <TableColumn mobile={false}>کلید یکتا زمان ارسال</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_key}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_title}</TextView>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
